import React from 'react';
import { observer } from 'mobx-react-lite';

import { StripComponent } from './StripComponent';
import { MobileDayStartStrip } from './day-start-strip.mobile';
import { Property } from '../../../app/entities/property';

import type { DayBreakStrip, Strip, Stripboard } from '../../../app/entities';

import styles from './shooting-schedule-table.mobile.module.scss';
type ShootingScheduleTableProps = {
  stripboard: Stripboard;
  placeholder?: React.ReactNode;
  properties: Property[];
  shootingDays: Stripboard['shootingDays'];
};

export const MobileShootingScheduleTable: React.FC<ShootingScheduleTableProps> = observer(
  ({ stripboard, placeholder, properties, shootingDays }) => {
    const firstDayBreakStrip = shootingDays?.[0]?.strips?.find(
      (strip) => strip.type === 'dayBreak',
    );

    return (
      <div className={styles['container']}>
        {placeholder ? (
          placeholder
        ) : (
          <>
            {firstDayBreakStrip && (
              <MobileDayStartStrip
                stripboard={stripboard}
                strip={firstDayBreakStrip as DayBreakStrip}
              />
            )}

            {shootingDays?.map((shootingDay) => {
              return shootingDay?.strips?.map((strip) => (
                <StripComponent
                  key={strip._id}
                  stripboard={stripboard}
                  properties={properties}
                  strip={strip}
                  screenType="mobile"
                />
              ));
            })}
          </>
        )}
      </div>
    );
  },
);
